var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashWalletDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M10 0C10.3978 0 10.7792 0.158149 11.0605 0.439453C11.3419 0.720758 11.5 1.10218 11.5 1.5V4H16V5H15.46L14.498 16.542C14.4872 17.1898 14.2265 17.8087 13.7676 18.2676C13.2987 18.7364 12.663 19 12 19H4C3.33696 19 2.70126 18.7364 2.23242 18.2676C1.77349 17.8086 1.51283 17.1898 1.50195 16.542L0.540039 5H0V4H4.5V1.5C4.5 1.10218 4.65815 0.720758 4.93945 0.439453C5.22076 0.158149 5.60218 0 6 0H10ZM2.49805 16.458L2.5 16.4795V16.5C2.5 16.8978 2.65815 17.2792 2.93945 17.5605C3.22076 17.8419 3.60218 18 4 18H12C12.3978 18 12.7792 17.8419 13.0605 17.5605C13.3419 17.2792 13.5 16.8978 13.5 16.5V16.4795L13.502 16.458L14.457 5H1.54297L2.49805 16.458ZM6.5 14.5H5.5V8.5H6.5V14.5ZM10.5 14.5H9.5V8.5H10.5V14.5ZM6 1C5.86739 1 5.74025 1.05272 5.64648 1.14648C5.55272 1.24025 5.5 1.36739 5.5 1.5V4H10.5V1.5C10.5 1.36739 10.4473 1.24025 10.3535 1.14648C10.2597 1.05272 10.1326 1 10 1H6Z",
    fill: "#FF5353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashWalletDeleteIcon);
export default __webpack_public_path__ + "static/media/cash-wallet-delete-icon.2d2a5c825921bc4fbc23b06f2491d8a1.svg";
export { ForwardRef as ReactComponent };